import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { CommonService } from '~util/common.service';
import { AdminService } from '~admin/services/admin.service';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-bulk-create',
  templateUrl: './bulk-create.component.html',
  styleUrls: ['./bulk-create.component.css']
})
export class BulkCreateComponent implements OnInit {

  buttonText: string;
  disabled: boolean;
  file: File;
  targetEnvironment: FormControl;
  createCustomFolder: FormControl;

  constructor(public dialogRef: MatDialogRef<BulkCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AdminService,
    private commonService: CommonService) {

  }

  ngOnInit() {
    this.targetEnvironment = new FormControl(this.data.env, Validators.required);
    this.createCustomFolder = new FormControl(false, Validators.required);
    this.buttonText = "Create Datasources";
    this.disabled = true;

    this.targetEnvironment.valueChanges.subscribe(value => {
      if (this.file && this.targetEnvironment.value) {
        this.disabled = false;
      }
    });
  }

  bulkCreate() {

    let formData = new FormData();
    formData.append("file", this.file, this.file.name);
    formData.append("envName", this.targetEnvironment.value);
    formData.append("createCustomFolder", this.createCustomFolder.value);

    this.service.bulkCreate(formData).subscribe(() => {
      let data = {
        header: 'Success',
        message: 'New Datasources created successfuly!'
      }
      this.commonService.showDialog(data);
      this.commonService.reload();
      this.close();
    });
  }

  close() {
    this.dialogRef.close();
  }

  setFile(file: File) {
    this.file = file;
    if (this.file && this.targetEnvironment.value) {
      this.disabled = false;
    }
  }

  download() {
    this.service.getSampleJson().subscribe((data) => {
      var blob = new Blob([JSON.stringify(data, null, 2)], { type: 'text/json' });
      saveAs(blob, 'SampleJson_BulkUpdate.json');
    });
  }

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/datasource/bulk-create/bulk-create.component.ts